module.exports = __webpack_public_path__ + "static/media/arrow_right.c5e67def.svg";